 const languagePath = process.env.VUE_APP_Language as string; 
import { createI18n } from 'vue-i18n';
import zh from './zh'; 
import id from './id'
import en from './en'
import vi from './vi'

const messages = { 
    zh,
    id,
    vi,
    en
};

const i18n = createI18n({
    locale: languagePath,
    messages,
});

export default i18n;